
import { ChefHat, DollarSign, Heart } from "lucide-react";
import { StatCard } from "./StatCard";
import type { SupabaseAnalytics } from "@/types/analytics";

interface AnalyticsOverviewProps {
  analytics: SupabaseAnalytics | undefined;
  isLoading: boolean;
}

export const AnalyticsOverview = ({ analytics, isLoading }: AnalyticsOverviewProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatCard
        title="Total Recipes"
        value={analytics?.recipe_count || 0}
        icon={ChefHat}
        isLoading={isLoading}
      />
      <StatCard
        title="Earnings"
        value={`$${analytics?.earnings || 0}`}
        icon={DollarSign}
        isLoading={isLoading}
      />
      <StatCard
        title="Total Likes"
        value={analytics?.total_likes || 0}
        icon={Heart}
        isLoading={isLoading}
      />
      <StatCard
        title="Most Popular Recipe"
        value={analytics?.most_popular_recipe || "None"}
        icon={Heart}
        isLoading={isLoading}
      />
    </div>
  );
};
